import React, { useEffect, useState } from "react";
import downloadImg from "../../../assets/download-img.svg";
import WorkTypeFilter from "../../../components/Filters/WorkTypeFilter";
import SpecialitiesFilters from "./SpecialitiesFilters";
import AxiosInstance from "../../../utils/axiosInstance";
import loader from "../../../assets/loader.svg";
import toast from "react-hot-toast";
import { use } from "react";
export default function MappedSpecialities({ selectedSpecialityId, onMappingSaved }) {

    console.log("Selected Speciality ID:", selectedSpecialityId);
    const [selectedSpeciality, setSelectedSpeciality] = useState();
    const [selectedHighway, setSelectedHighway] = useState([]);
    const [selectedBuilding, setSelectedBuilding] = useState([]);
    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingFilter, setIsLoadingFilter] = useState(false); // loader for filters


    useEffect(() => {
        if (selectedSpecialityId) {
            console.log("Updating selected speciality to:", selectedSpecialityId);
            setSelectedSpeciality(selectedSpecialityId);
            fetchPreselectedWorktypes(selectedSpecialityId);
        }
    }, [selectedSpecialityId]);
    /** fetch preselected highway & building worktypes for a speciality */
    const fetchPreselectedWorktypes = async (specialityId) => {
        try {
            setIsLoadingFilter(true);

            const res = await AxiosInstance.get(
                `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_PECIALITY_BY_ID}`,
                { params: { speciality_id: specialityId } }
            );

            const { highway = [], building = [] } = res.data?.data || {};

            setSelectedHighway({ highway });
            setSelectedBuilding({ building });
            toast.success(res.data?.message || "Preselected worktypes loaded.");

        } catch (err) {
            console.error("Failed to load preselected worktypes:", err);
            setErrorMsg("Unable to load saved mapping for this speciality.");
            setSelectedHighway({ highway: [] });
            setSelectedBuilding({ building: [] });
            toast.error("Unable to load saved mapping for this speciality");

        } finally {
            setIsLoadingFilter(false);
        }
    };

    const handleSpecialityChange = (selected) => {
        setSelectedSpeciality(selected);
        setErrorMsg("");

        if (selected) {
            fetchPreselectedWorktypes(selected);
        } else {
            setSelectedHighway([]);
            setSelectedBuilding([]);
        }
    };

    const handleHighwayChange = (selected) => {
        console.log("Selected Highway Worktypes:", selected);

        setSelectedHighway({ highway: selected });
        setErrorMsg("");
    };

    const handleBuildingChange = (selected) => {
        console.log("Selected Building Worktypes:", selected);
        setSelectedBuilding({ building: selected });
        setErrorMsg("");
    };

    const handleSave = async () => {
        if (!selectedSpeciality || selectedSpeciality === "") {
            setErrorMsg("Please select a Speciality.");
            return;
        }
        if (
            (!selectedHighway || selectedHighway.length === 0) &&
            (!selectedBuilding || selectedBuilding.length === 0)
        ) {
            setErrorMsg("Please select at least one Highway or Building Worktype.");
            return;
        }
        console.log("Saving speciality_id:", selectedSpeciality);
        console.log("Saving selectedHighway:", selectedHighway);
        console.log("Saving selectedBuilding:", selectedBuilding);

        try {
            setErrorMsg("");
            setIsLoading(true);

            const payload = {
                speciality_id: selectedSpeciality,
                highway_ids: selectedHighway?.highway || [],
                building_ids: selectedBuilding?.building || [],
            };

            const response = await AxiosInstance.post(
                `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_SAVE_SPECIALITY_MAPPING}`,
                payload
            );

            if (response.data?.statusCode === 200) {
                onMappingSaved();
                toast.success(response.data?.message || "Mapping saved successfully");
            } else {
                toast.error(response.data?.message || "Failed to save mapping");
            }
        } catch (err) {
            console.error("Save failed:", err);
            setErrorMsg("Something went wrong while saving.");
            toast.error(err?.message || "Something went wrong while saving.");


        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="col-12 col-md-12 pb-4">
            <div className="card w-100 h-100 bg-white rounded-3 shadow-sm mb-4 border-0">
                <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-light border-2">
                    <div className="row g-0">
                        <div className="col g-0">
                            <h3 className="p-3 mb-0 pb-0 point-22 text-uppercase text-primary fw-bold">
                                Mapped Specialities
                            </h3>
                        </div>
                        <div className="col-auto bg-secondary">
                            <div className="rounded-pill bg-secondary w-100">
                                <div className="d-flex flex-column justify-content-center">
                                    <img src={downloadImg} className="header-icon m-2" alt="logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-body p-3">
                    <div className="row g-3">
                        <div className="col-md-4">
                            <b>Specialities :</b>
                            <br />
                            <SpecialitiesFilters
                                onSelectSpecilities={handleSpecialityChange}
                                borderTrue={false}
                                ismultiple={false}
                                preSelectedValues={[selectedSpeciality]}
                                isdisabled={false}
                                no_used_cached
                            />
                        </div>

                        <div className="col-md-4">
                            <b>Worktypes Highway :</b>
                            <br />
                            {isLoadingFilter ? (
                                <div className="d-flex align-items-center">
                                    <img src={loader} alt="loading" style={{ width: 20, height: 20, marginRight: 8 }} />
                                    Loading...
                                </div>
                            ) : (
                                <WorkTypeFilter
                                    onSelectWorkType={handleHighwayChange}
                                    ismultiple
                                    preSelectedValues={selectedHighway}
                                    isdisabled={isLoadingFilter}
                                    placeholder="Select Worktypes Highway"
                                    no_used_cached
                                />
                            )}
                        </div>

                        <div className="col-md-4">
                            <b>Worktypes Building :</b>
                            <br />
                            {isLoadingFilter ? (
                                <div className="d-flex align-items-center">
                                    <img src={loader} alt="loading" style={{ width: 20, height: 20, marginRight: 8 }} />
                                    Loading...
                                </div>
                            ) : (
                                <WorkTypeFilter
                                    onSelectWorkType={handleBuildingChange}
                                    ismultiple
                                    preSelectedValues={selectedBuilding}
                                    isdisabled={isLoadingFilter}
                                    isBuildingFilter
                                    placeholder="Select Worktypes Building"
                                    no_used_cached
                                />
                            )}
                        </div>
                    </div>

                    <br />

                    <div className="row g-3 justify-content-end align-items-center">
                        {errorMsg && (
                            <div className="col-12 col-md text-danger fw-bold">{errorMsg}</div>
                        )}

                        <div className="col-6 col-md-auto">
                            <button
                                className="btn btn-primary text-uppercase fw-bold rounded-pill w-100 d-flex justify-content-center align-items-center"
                                onClick={handleSave}
                                disabled={isLoading || isLoadingFilter}
                            >
                                {isLoading ? (
                                    <>
                                        <img
                                            src={loader}
                                            alt="loading"
                                            style={{ width: 20, height: 20, marginRight: 8 }}
                                        />
                                        Saving...
                                    </>
                                ) : (
                                    "Save"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
